import React, { useEffect, useState } from 'react'
import {
    BtnLayerClose,
    BtnUrlCopy,
    ButtonSNS, CloseIcon, CopyComplete, CopyUrl,
    LayerPop,
    ShareSnsList,
    ShareSNSpop, WrapperCopyCompelte,InputWrapper, BtnLayerCloseBottom, Popname
} from "./share_layer.style";

const ShareMobileLayer = ({ setIsShowLayer }) => {
    const [isCopy, setIsCopy] = useState(false);
    const snsData = {
        title : '쇼핑 큐레이션 · 행복쇼핑',
        description: '행복쇼핑은 컴퓨터, 조립PC에 특화된 온라인 견적 가격비교 사이트 입니다. 안전구매시스템(전자보증,에스크로)을 갖춘 쇼핑몰, 미니샵의 최저 가격 정보를 보여드립니다. 쇼핑의 행복! 행복쇼핑',
        imageUrl: process.env.REACT_APP_TLD === 'kr'
            ? `https://cdnimg.happyshopping.kr/img_static/img_pres/_v3/kakao_002.jpg`
            :`https://cdnimg-${process.env.REACT_APP_TLD}.happyshopping.kr/img_static/img_pres/_v3/kakao_002.jpg`
    }
    const location = window.location.href

    const onClickClose = () => {
        setIsShowLayer(false)
    }

    const onClickCopy = () => {
        window.navigator.clipboard.writeText(location)
        setIsCopy(true)
    }

    const onClickKakaoTalk = () => {
        if (!window.Kakao.isInitialized()) {
            window.Kakao.init('d98008c5b7924c032845dea5e5d12b26');
        }

        window.Kakao.Share.sendDefault({
            objectType: 'feed',
            content: {
                title: snsData.title,
                description: snsData.description,
                imageUrl: snsData.imageUrl,
                imageWidth: 800,
                imageHeight: 400,
                link: {
                    mobileWebUrl: location,
                    webUrl: location,
                },
            },
            buttons: [
                {
                    title: '행복쇼핑에서 보기',
                    link: {
                        mobileWebUrl: location,
                        webUrl: location,
                    },
                },
            ],
        })
    }

    const onClickLine = () => {
        const text = encodeURIComponent(snsData.title)
        window.open(
            `http://line.me/msg/text/?${text} : ${location}`,
            'snsPop',
            'toolbar=yes,scrollbars=yes,resizable=yes,top=100,left=100,width=600,height=500',
        )
    }

    const onClickFacebook = () => {
        window.open(
            `http://www.facebook.com/sharer/sharer.php?u=${location}`,
            'snsPop',
            'toolbar=yes,scrollbars=yes,resizable=yes,top=100,left=100,width=500,height=600',
        )
    }

    const onClickKakaoStory = () => {
        window.open(
            `https://story.kakao.com/share?url=${location}`,
            'snsPop',
            'toolbar=yes,scrollbars=yes,resizable=yes,top=100,left=100,width=500,height=600',
        )
    }


    const onClickTwitter = () => {
        const text = encodeURIComponent(snsData.title)
        window.open(
            `//twitter.com/share?text=${text}&url=${location}`,
            'snsPop',
            'toolbar=yes,scrollbars=yes,resizable=yes,top=100,left=100,width=650,height=500',
        )
    }

    useEffect(() => {
        const script = document.createElement('script');
        script.src = 'https://t1.kakaocdn.net/kakao_js_sdk/2.0.1/kakao.min.js';
        script.async = true;
        document.body.appendChild(script);
    }, []);

    return (
        <React.Fragment>
            <LayerPop id='card_layer_wrapper'>
                <ShareSNSpop >
                    <Popname>공유하기</Popname>
                    <ShareSnsList>
                        <ButtonSNS type="button" onClick={onClickKakaoTalk}>
                            <img
                                src={`${process.env.REACT_APP_CDN_IMG}/img_static/img_mobile/comm/sns_kakaotalk.png`}
                                alt="카카오톡"
                            />
                            <span>카카오톡</span>
                        </ButtonSNS>
                        <ButtonSNS type="button" onClick={onClickLine}>
                            <img src={`${process.env.REACT_APP_CDN_IMG}/img_static/img_mobile/comm/sns_line.png`} alt="라인"/>
                            <span>라인</span>
                        </ButtonSNS>
                        <ButtonSNS type="button" onClick={onClickFacebook}>
                            <img
                                src={`${process.env.REACT_APP_CDN_IMG}/img_static/img_mobile/comm/sns_facebook.png`}
                                alt="페이스북"
                            />
                            <span>페이스북</span>
                        </ButtonSNS>
                        <ButtonSNS type="button" onClick={onClickKakaoStory}>
                            <img
                                src={`${process.env.REACT_APP_CDN_IMG}/img_static/img_mobile/comm/sns_kakaostory.png`}
                                alt="카카오스토리"
                            />
                            <span className="kakao_story">카카오스토리</span>
                        </ButtonSNS>
                        <ButtonSNS type="button" onClick={onClickTwitter} >
                            <img
                                src={`${process.env.REACT_APP_CDN_IMG}/img_static/img_mobile/comm/sns_twitter.png`}
                                alt="트위터"
                            />
                            <span>트위터</span>
                        </ButtonSNS>
                    </ShareSnsList>
                    <InputWrapper >
                        <CopyUrl type="text" readOnly=""
                            defaultValue={location}
                        />
                        <BtnUrlCopy type="button" onClick={onClickCopy}>
                            URL복사
                        </BtnUrlCopy>
                    </InputWrapper>
                    {isCopy &&
                        <WrapperCopyCompelte>
                            <CopyComplete>URL이 복사되었습니다</CopyComplete>
                        </WrapperCopyCompelte>
                    }
                    <BtnLayerClose type="button" className="btn_layer_clse"
                        onClick={onClickClose}
                    >
                        <CloseIcon className="icon-close"/>
                        <span className="ir">닫기</span>
                    </BtnLayerClose>
                    <BtnLayerCloseBottom>
                        <button type="button" onClick={onClickClose}>
                            확인
                        </button>
                    </BtnLayerCloseBottom>
                </ShareSNSpop>
            </LayerPop>
        </React.Fragment>
    )
}

export default ShareMobileLayer



// WEBPACK FOOTER //
// ./src/estimate_list/components/share/newShare/share_layer/index.js